export default "__VITE_ASSET__a149474d__"